import {
  ApplySchemaAttributes,
  MarkExtension,
  MarkExtensionSpec,
  MarkSpecOverride,
  extension,
} from 'remirror';

export interface TempoMarkOptions {
  className?: string;
}

const defaultOptions: Required<TempoMarkOptions> = {
  className: 'tempo-mark',
};

@extension<TempoMarkOptions>({
  defaultOptions,
  staticKeys: [],
  handlerKeys: [],
  customHandlerKeys: [],
})
export class TempoMark extends MarkExtension<TempoMarkOptions> {
  get name() {
    return 'tempo' as const;
  }

  createMarkSpec(
    extra: ApplySchemaAttributes,
    override: MarkSpecOverride
  ): MarkExtensionSpec {
    return {
      ...override,
      inclusive: false,
      excludes: 'tempo',
      attrs: {
        ...extra.defaults(),
        value: { default: '' },
      },
      parseDOM: [
        {
          tag: 'tempo',
          getAttrs: (dom: Node | string) => {
            const el = dom as Element;
            return {
              ...extra.parse(dom),
              value: el.getAttribute('value') ?? '',
            };
          },
        },
        ...(override.parseDOM ?? []),
      ],
      toDOM: node => {
        const attrs: Record<string, string | number | undefined> = {
          ...extra.dom(node),
          class: this.options.className,
          value: node.attrs.value,
        };
        return ['tempo', attrs, 0];
      },
    };
  }
}

export default TempoMark;
